import { IBusinessContentItem } from "features/business-compliance/selected-business/types";

import { IStyledSelectOption } from "ui/styled-select/types";

export const ODP_CUT_OFF_VALUE = 2;
export const salaryDateOptions: IStyledSelectOption[] = [
  {
    label: "1st",
    value: "1",
  },
  {
    label: "2nd",
    value: "2",
  },
  {
    label: "3rd",
    value: "3",
  },
  {
    label: "4th",
    value: "4",
  },
  {
    label: "5th",
    value: "5",
  },
  {
    label: "6th",
    value: "6",
  },
  {
    label: "7th",
    value: "7",
  },
  {
    label: "8th",
    value: "8",
  },
  {
    label: "9th",
    value: "9",
  },
  {
    label: "10th",
    value: "10",
  },
  {
    label: "11th",
    value: "11",
  },
  {
    label: "12th",
    value: "12",
  },
  {
    label: "13th",
    value: "13",
  },
  {
    label: "14th",
    value: "14",
  },
  {
    label: "15th",
    value: "15",
  },
  {
    label: "16th",
    value: "16",
  },
  {
    label: "17th",
    value: "17",
  },
  {
    label: "18th",
    value: "18",
  },
  {
    label: "19th",
    value: "19",
  },
  {
    label: "20th",
    value: "20",
  },
  {
    label: "21st",
    value: "21",
  },
  {
    label: "22nd",
    value: "22",
  },
  {
    label: "23rd",
    value: "23",
  },
  {
    label: "24th",
    value: "24",
  },
  {
    label: "25th",
    value: "25",
  },
  {
    label: "26th",
    value: "26",
  },
  {
    label: "27th",
    value: "27",
  },
  {
    label: "28th",
    value: "28",
  },
  {
    label: "29th",
    value: "29",
  },
  {
    label: "30th",
    value: "30",
  },
  {
    label: "31st",
    value: "31",
  },
];

export const whoPaysWithdrawalFeesOptions: IStyledSelectOption[] = [
  {
    label: "Employer",
    value: "employer",
  },
  {
    label: "Employee",
    value: "employee",
  },
];

export const withdrawalSetUpOptions: IStyledSelectOption[] = [
  {
    label: "Allow Auto Withdrawal",
    value: "true",
  },
  {
    label: "Require Approval",
    value: "false",
  },
];

export const employeeAccessOptions: IStyledSelectOption[] = [
  {
    label: "50%",
    value: "50",
  },
  {
    label: "75%",
    value: "75",
  },
];

export const businessODPConfigList: IBusinessContentItem[] = [
  {
    title: "Salary Date",
    content: "N/A",
  },
  {
    title: "Who pays withdrawal fee?",
    content: "N/A",
  },
  {
    title: "Withdrawal Setup",
    content: "N/A",
  },
  {
    title: "Employee Access",
    content: "N/A",
  },
  {
    title: "Cut-Off Date",
    content: "N/A",
  },
  {
    title: "Activate Roll Over",
    content: "N/A",
  },
  /*  {
    title: "Set all Employee Earnings",
    content: "N/A",
  },
  {
    title: "Set Multiple Employee Earnings",
    content: "N/A",
  }, */
];
